import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Placeholder from 'components/consumer/Placeholder';
const PDPCompleteOrderPlaceholder = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Placeholder type="rect" loading={true} className="!w-full !h-[56px]" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex flex-col w-full min-h-[200px] mt-8">{t0}<div className="flex flex-row items-start my-6"><Placeholder type="rect" loading={true} className="!w-[18px] !h-[18px] rounded-sm" /><Placeholder type="text" rows={2} loading={true} className="!w-full !h-[47px]" /></div><Placeholder type="rect" loading={true} className="!w-full !h-[52px]" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default PDPCompleteOrderPlaceholder;